import React, { useState, useEffect, useContext } from 'react'
import { GlobalContext } from '../../context/GlobalState'
import axios from 'axios'
import Loader from './Loader'
import SinglePV from './SinglePV'

const PV = () => {

    const { openDetailsView } = useContext(GlobalContext)

    const [loading, setLoading] = useState(true);
    const [pvs, setPVs] = useState([])

    const fetchPVs = async () => {
        const res = await axios('https://energie.haffhus.de/api/v1/pvs')
        //res.data.sort((a, b) => { return b.value - a.value })
        setPVs(res.data)
    }

    useEffect(() => {
        const initLoop = async () => {
            await fetchPVs();
            setTimeout(() => {
                setLoading(false);
            }, 1500)
            setInterval(fetchPVs, 10000)
        }

        initLoop();

        return () => {
            clearInterval(initLoop)
        }
    }, [])


    return (
        <div className={`grid photovoltaik`} style={!openDetailsView ? { WebkitOverflowScrolling: 'touch' } : {}}>
            {loading ?
                <Loader />
                :
                pvs.map((pv, i) => (
                    <SinglePV pv={pv} key={i} />
                ))
            }
        </div>
    )
}

export default PV
